import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { CoursesState } from 'reducers/courses';

const useCourses = (): CoursesState => {
  return useSelector((state: RootState) => state.courses);
};

export default useCourses;
